import React, {useCallback, useEffect, useState} from "react";
import VideoJS from "../../video/videoJS.components";
import {useQuery} from '../../../../hook/useQuery'
import './sessionManage.scss'
import {SessionActions} from '../../../../store/session/session.action';
import {
  Row,
  Col,
  Table,
  Button,
  Container,
  Card,
  CardHeader,
  CardBody,
  Input, Nav, NavItem, NavLink, TabContent, TabPane, Spinner, Form,
} from "reactstrap";
import {SESSION} from "../../../../__mock__/session/detail";
import {SessionDropdown} from "../components/dropdown/sessionDropdowns";
import {useDispatch, useSelector} from "react-redux";
import {timeUtil} from "../utils/time";
import {SessionSelectors} from "../../../../store/session/session.selector";
import sessions from "../../../sessions/sessionsutils";
import {SpeakersActions} from "../../../../store/speakers/speakers.action";
import {toast} from "react-toastify";
import {transcription as transcriptionApi} from "../../../../api/trascription";
import {transcriptionUtils} from "../../../../utils/trascription.utils";
import {Transcription} from "../../transcription/Transcription";
import {sessionManageUtils} from "./sessionManage.utils";
import {recorder} from "../../../../api/recorder";
import SessionNotFound from "../components/notFound/SessionNotFound";
import * as _ from 'lodash';
import {Handles, Rail, Slider, Ticks, Tracks} from "react-compound-slider";
import {Handle, SliderRail, Tick, Track} from "../components/slider/DSlider";
import {SocialShare} from "../../socialShare/SocialShare";
import {downloadFile} from "../../../../utils/download.utils";
import {speaker} from "../../../../api/speaker";

const {timeToStringFormat} = timeUtil

const initialFormState = {
  time: 0,
  evento: {},
  speaker: '',
  speaker_id: null,
  fase: {},
  testo: ''
}

const domain = [100, 500];
const defaultValues = [100, 500];
const sliderStyle = {
  position: "relative",
  width: "100%"
};


const SessionManage = () => {
  const query = useQuery();
  const dispatch = useDispatch();
  const sessionId = query.get('id');

  const session = useSelector(SessionSelectors.get)
  const sessionLoading = useSelector(SessionSelectors.isLoading)
  const sessionError = useSelector(SessionSelectors.isError)

  const [showOtherSpeakerField, setShowOtherSpeakerField] = useState(false);

  // const speakerList = useSelector(SpeakersSelectors.get)
  // const speakersLoading = useSelector(SpeakersSelectors.isLoading)
  // const speakersError = useSelector(SpeakersSelectors.isError)

  const playerRef = React.useRef(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [playLabel, setPlayLabel] = useState('play');

  const [shareUrl, setShareUrl] = useState('')
  const [events, setEvents] = useState(SESSION.events);
  const [faseSeduta, setFaseSeduta] = useState(SESSION.faseSeduta);
  // const [speakers, setSpeakers] = useState([]);
  const [tab, setTab] = useState("1");
  const [form, setForm] = useState(initialFormState)
  const [playerTime, setPlayerTime] = useState('')
  const [videoLoaded, setVideoLoaded] = useState(false);
  const [timeNotes, setTimeNotes] = useState([])
  const [transcription, setTranscription] = useState({});
  const [elasticSearch, setElasticSearch] = useState({});
  const [addedTimeNote, setAddedTimeNote] = useState(false);
  const [listarelatori, setListaRelatori] = useState([]);
  const [speakerId, setSpeakerId] = useState('');
  const [sliderDomain, setSliderDomain] = useState([0, 1]);
  const [sliderDefaultValues, setSliderDefaultValues] = useState([0, 1]);
  const [currentCut, setCurrentCut] = useState([]);
  const [videoCut, setVideoCut] = useState({});
  const [isCutLoading, setIsCutloading] = useState(false);
  const [videoJsOptions, setVideoJsOptions] = useState(
    { // lookup the options in the docs for more options
      autoplay: false,
      controls: true,
      responsive: true,
      fluid: true,
      sources: [{
        src: '',
        type: 'video/mp4'
      }]
    }
  )

  useEffect(async () => {
    await load();
  }, []);

  const load = async () => {

  }


  useEffect(() => {
    const baseShare1 = window.location.href.split('manage?id=',)[0];
    const baseShare = baseShare1 + 'view?id=';
    setShareUrl(baseShare);
    return () => {
      dispatch(SessionActions.reset());
    }
  }, [])

  useEffect(() => {
    if (sessionId) {
      dispatch(SessionActions.fetchSessionById(sessionId))
      loadElasticSearchSession(sessionId)

    }
  }, [sessionId])


  useEffect(async () => {
    if (session) {

      console.log('session render.')
      let parsedTimeNotes = []
	    if(session.timenote){
		    try{
  			  parsedTimeNotes = JSON.parse(session.timenote);
          console.log('parsedTimeNotes',parsedTimeNotes);
  		  }catch(e){
    			console.debug("Error parsing timenote");
    			console.debug(session.timenote);
    			console.debug(e);
    		}
	    }
      setTimeNotes(parsedTimeNotes);

      if (session.linkVideo) {
        setVideoJsOptions(v => {
          const videoOptions = v;
          videoOptions.sources[0].src = session.linkVideo;
          return videoOptions
        })
        setVideoLoaded(true);

      }

  	  if (session.trascrizioni?.pvt || session.trascrizioni?.originalFile) {
        loadTranscription(session.trascrizioni.pvt || session.trascrizioni.originalFile);
      }

      // Load Speaker Gropus
      console.log('Session', session)
      try {
        if (session.idSpeakerGroup) { 
          const listaRelatori = await speaker.methods.loadRelatoriGruppo(session.idSpeakerGroup);
          setListaRelatori(listaRelatori);
        }
      } catch (e) {
        toast.error('Impossibile recuperare la lista dei relatori');
        console.log('Impossibile recuperare la lista dei relatori');
      }

    }
  }, [session])

  async function loadElasticSearchSession(sessionId) {
    try {
      const search = await sessions.methods.queryElasticSearch(sessionManageUtils.searchSessionParams({
        groupId: localStorage.getItem('grp'),
        ownerId: localStorage.getItem('id'),
        roleType: localStorage.getItem('rl').toUpperCase(),
        sessionId,
        toString: true
      }));
      //console.log('[api/audioma/v1/query]: The payload of the search is empty')
      //console.log(search)
      if (search.payload.length == 0) {
        toast.warn('Sessione non trovata su elastic search');
      } else {
        const searchResponse = search.payload[0].videoItem;
        console.log('SEARCH: ', searchResponse);
        setElasticSearch(searchResponse);
      }

    } catch (e) {
      console.error(e);
      console.log('errore loadElasticSearch')
      toast.error('Qualcosa è andato storto');
    }

  }

  async function loadTranscription(link) {
    const transcriptionResult = await transcriptionApi.methods.getTranscription(link);
    const convertedXml = transcriptionUtils.methods.convertXmlToJson(transcriptionResult);
    const cleanedJSON = convertedXml.replace(/"_/g, '"');

    try {
      setTranscription(JSON.parse(cleanedJSON))
    } catch (e) {
      setTranscription({})
    }
  }

  // useEffect(() => {
  //   setSpeakers(speakerList)
  // }, [speakerList])


  const onSetFormElement = (key, element, reset) => {
    // Show / Hide other speaker field 
    console.log('Set form element:', key, element);
    if (key == 'speaker_id' && element == 'other' ) {
      setShowOtherSpeakerField(true);
      setForm({
        ...form,
        ['speaker']: '',
        ['speaker_id']: null
      })
      
    } else {
      setShowOtherSpeakerField(false);

      setForm({
        ...form,
        [key]: element
      })
    }
    if (reset) {
      const eventId = form.id

      setForm({
          ...initialFormState,
          [key]: element,
          ['id']: eventId
        }
      );
      return;
    }

    console.log(form)
  }

  const onEventAdd = (e) => {
    e.preventDefault();
    console.log(form);
    setAddedTimeNote(true)
    if (!form.id) {
      const newTimeNotes = [
        ...timeNotes,
        {
          ...form,
          time: currentTime,
          id: Date.now()
        }
      ]
      newTimeNotes.sort((a, b) => a.time - b.time);
      setTimeNotes([
        ...newTimeNotes
      ]);
    } else {
      //  Edit
      const ix = timeNotes.findIndex(t => t.id === form.id);
      if (ix < 0) {
        console.error('Id not found in the list');
        return;
      } else {
        timeNotes[ix] = {...form, time: currentTime};
        timeNotes.sort((a, b) => a.time - b.time);
        setTimeNotes([...timeNotes])
      }

    }
    setForm(initialFormState);

  };


  async function updateSession({publish = false} = {}) {
    console.log('Session ', session);
    console.log('TimeNotes ', timeNotes);


    const sessionDTO = {
      ...session,
      timenote: JSON.stringify(timeNotes)
    }
    const typeTags = sessionManageUtils.prepareTypeTags(timeNotes);
    console.log(typeTags)
    const result = await sessions.methods.updateSession(sessionDTO);
    console.log(result);
    const search = elasticSearch;
    if (publish) {
      search.privacyType = 'PUBLIC';
      delete search.privacy
    } else {
      search.privacyType = 'GROUP';
    }
    const sessionRecorderDto = sessionManageUtils.prepareSessionRecorder(search, typeTags)

    const resultElastic = await recorder.methods.editInArchive(sessionRecorderDto)
    loadElasticSearchSession(sessionId);
    console.log(resultElastic);

    if (publish) {
      const resultSgmentSpeakers = await recorder.methods.segmentSpeakers({idSessione: sessionId});
      console.log(resultSgmentSpeakers);
    }
  }

  async function onSessionSave() {
    try {
      await updateSession();
	  console.debug("Saving session. addedTimeNote? ["+addedTimeNote+"]");
      if (addedTimeNote) {
        setAddedTimeNote(false);
        await recorder.methods.addSpeakersToTranslations({idSessione: sessionId});
        toast.success("Sessione aggiornata e conversione trascrizione in corso!");
      } else {
        toast.success("Sessione aggiornata!");

      }
    } catch (e) {
      toast.error("Qualcosa è andato storto...");
    }

  }

  async function onPublicSession(publish) {
    try {
      await updateSession({publish: publish});
      toast.success(`Sessione salvata e ${publish ? 'pubblicata' : 'nascosta'}!`);
    } catch (e) {
      console.log(e)
      toast.error("Qualcosa è andato storto...");
    }
  }

  function deleteTimeNote(e, timeNotePar) {
    e.stopPropagation();
    setTimeNotes(timeNote => timeNote.filter(tn => tn.id !== timeNotePar.id))
	setAddedTimeNote(true);
	console.debug("Deleted timenote. addedTimeNote? ["+addedTimeNote+"]");
  }

  function editTimeNote(e, timeNote) {
    e.stopPropagation();
    playerRef.current.currentTime(timeNote.time / 1000)
    const timeNoteCopy = _.cloneDeep(timeNote);
    timeNoteCopy.time = Math.trunc((timeNoteCopy.time / 1000))
    setForm(timeNoteCopy)
 

    console.log(timeNoteCopy);
	  setAddedTimeNote(true);
 
    setShowOtherSpeakerField(false)
    if (form?.evento?.id === 1) {
      try {
        document.getElementById('speaker_id').value = timeNoteCopy.speaker_id;
      } catch(e){

      }
      if(timeNoteCopy.speaker_id) {
        setShowOtherSpeakerField(false)
      } else {
        setShowOtherSpeakerField(true)
        document.getElementById('speaker_id').value = 'other';
      }
    }

	  console.debug("Edit timenote. addedTimeNote? ["+addedTimeNote+"]");
  }

  function onUpdateVideo([start, end]) {
    const [startCut, endCut] = currentCut;
    if (start !== startCut) {
      playerRef.current.currentTime(start)
    } else if (end !== endCut) {
      playerRef.current.currentTime(end);
    } else return;
    setCurrentCut([start, end])

  }

  const handlePlayerReady = (player) => {
    playerRef.current = player;
    // you can handle player events here
    player.on('waiting', () => {
      console.log('player is waiting');
    });

    player.on('dispose', () => {
      console.log('player will dispose');
    });

    //
    player.on('timeupdate', (e) => {
      setCurrentTime((player.currentTime().toFixed(3)) * 1000)
      const time = player.currentTime().toFixed(0);
      setPlayerTime(timeToStringFormat(time * 1000))

    })

    player.on('loadedmetadata', e => {

      const duration = playerRef.current.duration()
      setSliderDomain([0, duration])
      setSliderDefaultValues([0, duration])
      // setCurrentCut([0, duration])

    })
  };

  function togglePlay() {
    if (playerRef.current.paused()) {
      playerRef.current.play();
      setPlayLabel('pause')
    } else {
      playerRef.current.pause();
      setPlayLabel('play')

    }
  }


  function renderDescription(timeNote) {
    const {evento, speaker, fase, testo} = timeNote;
    if (evento.id === 1) {
      return speaker
    }
    if (evento.id === 2) {
      return fase.name
    }
    if (evento.id === 3) {
      return testo
    }
  }

  function goToTime(time) {
    playerRef.current.currentTime(time / 1000)
  }

  function backStep () {
    seekStep(-1000)
  }

  function forwardStep () {
    seekStep(1000)
  }

  function seekStep(amount) {
    goToTime(Math.max(0, Math.min(currentTime + amount, sliderDomain[1]*1000)))
  }

  const onWordClicked = useCallback((word) => {
    playerRef.current.currentTime(word.startTime)
  }, [playerTime.current])

  async function onCut() {
    setIsCutloading(true)
    const [start, end] = currentCut;
    const result = await recorder.methods.cutVideo({start, end, idSession: sessionId})
    setIsCutloading(false);
    setVideoCut(result);
  }

  return (
    <div className='streaming-container'> {sessionLoading && !session ?
      <Spinner/>
      : sessionError ? <SessionNotFound/> :
        <>
          <Row>
            <Col md="12" sm="12" lg="12"><h2>{session.name}</h2></Col>
          </Row>
          <Row style={{marginBottom: 45}}>
            {/*Column SX*/}
            <Col md="7" sm="7" lg="7">
              {videoLoaded && <>
                <Row>
                  <VideoJS options={videoJsOptions} onReady={handlePlayerReady}/>
                </Row>
                <Row style={{marginTop: 20, marginLeft: 75, marginRight: 120}}>
                  <Slider
                    mode={2}
                    step={0.5}
                    domain={sliderDomain}
                    rootStyle={sliderStyle}
                    onUpdate={onUpdateVideo}
                    onChange={onUpdateVideo}
                    values={sliderDefaultValues}
                  >
                    <Rail>
                      {({getRailProps}) => <SliderRail getRailProps={getRailProps}/>}
                    </Rail>
                    <Handles>
                      {({handles, getHandleProps}) => (
                        <div className="slider-handles">
                          {handles.map((handle) => (
                            <Handle
                              key={handle.id}
                              handle={handle}
                              domain={sliderDomain}
                              getHandleProps={getHandleProps}
                            />
                          ))}
                        </div>
                      )}
                    </Handles>
                    <Tracks left={false} right={false}>
                      {({tracks, getTrackProps}) => (
                        <div className="slider-tracks">
                          {tracks.map(({id, source, target}) => (
                            <Track
                              key={id}
                              source={source}
                              target={target}
                              getTrackProps={getTrackProps}
                            />
                          ))}
                        </div>
                      )}
                    </Tracks>
                    <Ticks count={5}>
                      {({ticks}) => (
                        <div className="slider-ticks">
                          {ticks
                            .map(tick => {
                              tick.value = timeToStringFormat(tick.value * 1000);
                              return tick
                            })
                            .map((tick) => (
                              <Tick key={tick.id} tick={tick} count={ticks.length}/>
                            ))}
                        </div>
                      )}
                    </Ticks>
                  </Slider>
                </Row>
                {_.isEmpty(videoCut) &&
                <Row style={{justifyContent: 'center', marginBottom: 10, marginTop: 45}}>
                  {isCutLoading ?
                    <>
                      <div className="loader-box" style={{minWidth:200, justifyContent:"space-between"}}>
                        <div className="loader-30"></div>
                           <span> Tagliando il video...</span>
                      </div>

                    </>
                    :
                    <Button color="info" onClick={() => onCut()}>Taglia</Button>
                  }
                </Row>
                }
              </>
              }


            </Col>

            {/*Column DX*/}
            <Col md="5" sm="5" lg="5">
              <Row>
                <Col sm="12">
                  <Nav className="border-tab-primary no-border" tabs>
                    <NavItem>
                      <NavLink
                        style={{cursor: 'pointer'}}
                        className={tab === "1" ? "active" : ""}
                        onClick={() => setTab("1")}
                      >
                        {/*<i className="icofont icofont-ui-home"></i>Home*/}
                        Indice
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink
                        style={{cursor: 'pointer'}}
                        className={tab === "2" ? "active" : ""}
                        onClick={() => setTab("2")}
                      >
                        {/*<i className="icofont icofont-man-in-glasses"></i>Profile*/}
                        Trascrizione interattiva
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <TabContent activeTab={tab}>
                    <TabPane className="fade show" tabId="1">
                      <Row>
                        <Col sm="12">
                          <div
                            className="table-responsive timeslot-table"
                          >
                            <Table striped>
                              <thead>
                              <tr>
                                <th scope="col" className="col col-md-1 col-lg-1">#</th>
                                <th scope="col" className="col col-md-2 col-lg-2">Tempo</th>
                                <th scope="col" className="col col-md-2 col-lg-2">Evento</th>
                                <th scope="col" className="col col-md-5 col-lg-5">Descrizione</th>
                                <th scope="col" className="col col-md-2 col-lg-2"></th>
                              </tr>
                              </thead>
                              <tbody>
                              {timeNotes.map((t, ix) => (
                                <tr key={t.id} onClick={() => goToTime(t.time)} style={{cursor: 'pointer'}}>
                                  <th scope="row" className="col col-md-1 col-lg-1">{ix + 1}</th>
                                  <td
                                    className="col col-md-2 col-lg-2">{timeToStringFormat(t.time)}</td>
                                  <td className="col col-md-2 col-lg-2">{t.evento.name}</td>
                                  <td className="col col-md-5 col-lg-5">{renderDescription(t)}</td>
                                  <td className="col col-md-2 col-lg-2">
                                    <Button
                                      onClick={(e) => editTimeNote(e, t)}
                                      className={'btn-sm btn-info icon-color icon-color-edit '}><i
                                      className="fa fa-pencil-square-o"/></Button>
                                    <Button
                                      onClick={(e) => deleteTimeNote(e, t)}
                                      className={'btn-sm btn-danger icon-color icon-color-trash m-l-5'}
                                    >
                                      <i className="fa fa-trash-o"/></Button>
                                  </td>
                                </tr>
                              ))}
                              </tbody>
                            </Table>
                          </div>
                        </Col>
                      </Row>
                    </TabPane>
                    <TabPane tabId="2">
                      <div className="mb-0 m-t-30 transcription-text">
                        <Transcription
                          currentPlayerTime={playerRef?.current?.currentTime()}
                          transcription={transcription}
                          onWordClicked={onWordClicked}/>
                      </div>
                    </TabPane>
                  </TabContent>
                </Col>
              </Row>
            </Col>
          </Row>
          {!_.isEmpty(videoCut) &&
          <>
            <Row style={{justifyContent: 'center', marginTop: 15}}>
              <SocialShare url={shareUrl + videoCut.idSession}/>
            </Row>
            <Row style={{justifyContent: 'center', marginTop: 15}}>
              <Col md="7" sm="7" lg="7">
                {/* TODO cambiare il link al download*/}
                <Button color="info" onClick={() => downloadFile(videoCut.linkVideo, videoCut.name)}>Download</Button>
              </Col>
            </Row>
          </>
          }
          <Container fluid={true} className="m-t-10">

            <Card>

              <CardBody className="dropdown-basic">
                <Row className="video-buttons-row">
                  <Col sm="12" xl="12">
                    <div className="form-row">
                      <Col md="3 mb-3" className="video-buttons-col">
                        <Button color={'primary'}
                          onClick={backStep}
                        ><i className={'icon-minus'}></i></Button>
                        <Input
                          disabled
                          value={playerTime}
                          className="form-control"
                          name="time"
                          type="text"
                          placeholder="00:00:00"
                        />
                        <Button color={'primary'}
                          onClick={forwardStep}
                        ><i className={'icon-plus'}></i></Button>
                      </Col>
                      <Col md="3 mb-3" className="video-buttons-col">
                        <SessionDropdown
                          label={'Evento'}
                          selected={form.evento}
                          list={events}
                          onClick={(e) => {
                            onSetFormElement('evento', e, true)
                          }}/>
                      </Col>
                      <Col md="3 mb-3" className="video-buttons-col">
                        {/*Oratore */}
                        {form?.evento?.id === 1 && (
                          <div>
                            {true && (
                            <select id="speaker_id" className="form-control btn-pill" onChange={(e) => {
                              
                              
                              if (e.currentTarget.value != 'other') {
                                console.log(listarelatori);
                                var speaker_obj = listarelatori.filter(obj => {
                                  return obj.id === e.currentTarget.value
                                })
                                console.log(speaker_obj, speaker_obj[0].name + ' ' + speaker_obj[0].surname);
                                setForm({
                                  ...form,
                                  ['speaker_id']: e.currentTarget.value,
                                  ['speaker']: speaker_obj[0].name + ' ' + speaker_obj[0].surname
                                })
                                
                                //onSetFormElement('speaker_id', e.currentTarget.value); 
                                setShowOtherSpeakerField(false);
                              } else {
                                setShowOtherSpeakerField(true);
                              }
                            }} size="1">
                              <option value='' disabled selected>Seleziona</option>
                              <option value='other'>Altro</option> 
                              {
                                Array.isArray(listarelatori) && listarelatori.length > 0 ? listarelatori.map((data, i) => {
                                  return (
                                    <option value={data.id}>{data.name} {data.surname} {data.description ? '-' : ''} {data.description}</option>
                                  );
                                }) : ''
                              }
                              
                            </select>
                            )}
                          </div>

             

                          /* <SessionDropdown
                             label={'Oratore'}
                             list={speakers}
                             selected={form.speaker}
                             onClick={(e) => onSetFormElement('speaker', e)}/> */
                        )}


                        {/*Fase seduta*/}
                        {form?.evento?.id === 2 && (
                          <SessionDropdown
                            label={'Fase'}
                            list={faseSeduta}
                            selected={form.fase}
                            onClick={(e) => onSetFormElement('fase', e)}/>
                        )}
                      </Col>

                      <Col md="3 mb-3" className="video-buttons-col">
                        {(form.evento.id === 3 || form.fase.id === 4) &&
                        <Input type="textarea"
                          value={form.testo}
                          onChange={(e) => onSetFormElement('testo', e.currentTarget.value)}
                          className="form-control"
                          name="time"
                          placeholder="Testo"
                        />}
                        {showOtherSpeakerField && (<Input
                          value={form.speaker}
                          onChange={(e) => {
                            setForm({
                                  ...form,
                                  ['speaker']: e.currentTarget.value
                                })
                            }
                            
                          }
                          className="form-control"
                          type="text"
                          placeholder="Nome dell'oratore"
                        />)}  
                      </Col>

                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md="12" sm="12" xl="12" className="text-md-right">
                    <Button className="video-button" color="danger"
                            onClick={() => setForm(initialFormState)}>Annulla</Button>
                    <Button className="video-button" color="info"
                            onClick={onEventAdd}>Add
                    </Button>
                  </Col>
                </Row>

                <div className="save-button-container">
                  <Button color="primary" onClick={onSessionSave}>Salva</Button>
                  {elasticSearch.privacy !== 'PUBLIC' ?
                    <Button style={{marginLeft: '10px'}} color="info" onClick={() => onPublicSession(true)}>
                      Salva e Pubblica
                    </Button> :
                    <Button style={{marginLeft: '10px'}} color="info" onClick={() => onPublicSession(false)}>Salva
                      e
                      Nascondi</Button>}
                </div>


              </CardBody>
            </Card>


          </Container>
        </>
    }
    </div>
  );
};


export default SessionManage
